import { formatMessage } from '../constants/strings/intl/intlHooks'
import { messages } from '../constants/strings/messages'

const monthName = [
  formatMessage(messages.month_january),
  formatMessage(messages.month_february),
  formatMessage(messages.month_march),
  formatMessage(messages.month_april),
  formatMessage(messages.month_may),
  formatMessage(messages.month_june),
  formatMessage(messages.month_july),
  formatMessage(messages.month_august),
  formatMessage(messages.month_september),
  formatMessage(messages.month_october),
  formatMessage(messages.month_november),
  formatMessage(messages.month_december),
]

const getLastTwelveMonths = () => {
  let lastTwelveMonths = []
  let currentDate = new Date()

  currentDate.setDate(1)
  for (let i = 0; i <= 11; i++) {
    lastTwelveMonths.push({
      id: `${currentDate.getMonth() + 1}/${currentDate.getFullYear()}`,
      text: `${monthName[currentDate.getMonth()]}/${currentDate.getFullYear()}`,
    })
    currentDate.setMonth(currentDate.getMonth() - 1)
  }

  return lastTwelveMonths
}

export const getLastTwelveMonthsForDropdown = () => {
  return getLastTwelveMonths()
}
